import { render, staticRenderFns } from "./TrStepByStepV2.vue?vue&type=template&id=b518dbb2&scoped=true&"
import script from "./TrStepByStepV2.vue?vue&type=script&lang=js&"
export * from "./TrStepByStepV2.vue?vue&type=script&lang=js&"
import style0 from "./TrStepByStepV2.vue?vue&type=style&index=0&id=b518dbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b518dbb2",
  null
  
)

export default component.exports